import services from '../services';
import { backOffDelay } from '../utils/helpers';
import { makeAutoObservable, observable } from 'mobx';

// do not rewrite this into a functional component, this is not a React component, it will always be a class, Barbora!!

class CommonStore {
    constructor() {
        // Ensure options (may contain React elements) are kept by reference, not deep-observed
        makeAutoObservable(this, { options: observable.ref });
    }

    message = null;
    appLoaded = false;
    messageType = null;
    messageShown = false;
    confirmationRequired = false;
    confirmationDescription = '';
    confirmationAction = '';
    options = {};
    confirmationOnConfirmAction;
    confirmationPasscode = '';
    confirmationShowCancel = true;
    confirmationTitle = '';
    isConfirmationDelete = false;
    additionalCheckbox = null;
    confirmationLoading = false;
    languagesLoaded = false;
    languages = [];
    messageTimeout = null;

    hideMessage() {
        this.message = null;
        this.messageShown = false;
        this.messageShown = false;
        try {
            clearTimeout(this.messageTimeout);
            // eslint-disable-next-line no-empty
        } catch (e) {}
        this.messageTimeout = null;
    }

    setAppLoaded() {
        this.appLoaded = true;
    }

    success(message) {
        this.showMessage(message, 'success');
    }

    warn(message) {
        this.showMessage(message, 'warning');
    }

    error(message) {
        this.showMessage(message, 'error');
    }

    showMessage(message, type = 'info', delay = 5000) {
        this.hideMessage();
        this.message = message;
        this.messageShown = true;
        this.messageType = type;
        this.messageTimeout = setTimeout(() => {
            this.hideMessage();
        }, delay);
    }

    getEntityName(entityType, entity) {
        switch (entityType) {
            case 'Request':
                return entity.location;
            case 'User':
                return entity.name || entity.email;
            case 'Customer':
                return entity.name;
            default:
                return entityType;
        }
    }

    showDeleteConfirm(entityType, entity, callback) {
        this.showConfirm(
            `Do you really want to delete ${this.getEntityName(
                entityType,
                entity
            )}`,
            'Delete',
            `Delete ${entityType}`,
            callback
        );
    }

    showConfirm(
        confirmationDescription,
        confirmationAction,
        confirmationTitle,
        confirmationOnConfirmAction,
        isConfirmationDelete = true,
        confirmationShowCancel = true,
        additionalCheckbox,
        options = {},
        confirmationLoading = false,
        modalWidth = null
    ) {
        this.confirmationDescription = confirmationDescription;
        this.confirmationAction = confirmationAction;
        this.options = { ...options, modalWidth };
        this.confirmationTitle = confirmationTitle;
        this.confirmationOnConfirmAction = confirmationOnConfirmAction;
        this.confirmationShowCancel = confirmationShowCancel;
        this.confirmationRequired = true;
        this.isConfirmationDelete = isConfirmationDelete;
        this.additionalCheckbox = additionalCheckbox;
        this.confirmationLoading = confirmationLoading;
    }

    showDeleteWithInputConfirm(
        confirmationDescription,
        confirmationAction,
        confirmationTitle,
        confirmationPasscode,
        confirmationOnConfirmAction,
        confirmationShowCancel = true
    ) {
        this.confirmationDescription = confirmationDescription;
        this.confirmationAction = confirmationAction;
        this.confirmationTitle = confirmationTitle;
        this.confirmationPasscode = confirmationPasscode;
        this.confirmationOnConfirmAction = (...args) => confirmationOnConfirmAction(...args);
        this.confirmationShowCancel = confirmationShowCancel;
        this.confirmationRequired = true;
    }

    cancelConfirm() {
        this.confirmationDescription = null;
        this.confirmationAction = null;
        this.confirmationTitle = null;
        this.confirmationOnConfirmAction = null;
        this.confirmationRequired = false;
        this.additionalCheckbox = null;
        this.isConfirmationDelete = false;
        this.options = {};
        this.confirmationLoading = false;
    }

    doConfirm(arg, passcodeValue = '') {
        if (this.confirmationOnConfirmAction) {
            if (this.confirmationPasscode !== '') {
                if (this.confirmationPasscode === passcodeValue)
                    this.confirmationOnConfirmAction(arg);
                else this.cancelConfirm();
            } else this.confirmationOnConfirmAction(arg);
        }

        this.cancelConfirm();
    }

    async loadLanguages(counter = 0) {
        this.languagesLoaded = false;

        try {
            let result = await services.Languages.list();
            this.languages.replace(result);
            this.languagesLoaded = true;
        } catch (e) {
            if (counter < 10)
                setTimeout(async () => {
                    await this.loadLanguages(counter + 1);
                }, backOffDelay(1500, counter));
        }
    }
}

export default CommonStore;
